<template>
  <div class="content">
    <div class="header">
      <div style="margin: 5px 0">
        <div>
          <SelectCdjProjectHeader :items="['type_id', 'place_id','region_id','project_id']" @onHeader="onHeader">
            <!--          <el-date-picker-->
            <!--            style="width: 150px"-->
            <!--            v-model="where.month_db"-->
            <!--            type="month"-->
            <!--            placeholder="选择统计月份"-->
            <!--            :clearable="false"-->
            <!--            format="yyyy-MM"-->
            <!--            value-format="yyyy-MM" >-->
            <!--          </el-date-picker>-->
            <el-date-picker
              style="width: 150px"
              size="mini"
              v-model="where.start_time"
              type="date"
              placeholder="选择开始日期"
              :clearable="false"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" :picker-options="forbiddenStartTime">
            </el-date-picker>
            <el-date-picker
              style="width: 150px"
              size="mini"
              v-model="where.day_time"
              type="date"
              placeholder="选择日期"
              :clearable="false"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" :picker-options="forbiddenStartTime">
            </el-date-picker>
            <el-select v-model="where.position_id" class="m-2" filterable placeholder="选择职务" clearable size="mini">
              <el-option
                v-for="item in position_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-input v-model="where.user_name" placeholder="姓名搜索" style="width: 150px" size="mini"></el-input>

            <el-button size="mini" @click="exportExcel" type="primary">导出明细</el-button>
          </SelectCdjProjectHeader>
        </div>
      </div>
    </div>

    <div class="body">
      <el-tabs type="border-card" v-model="card_index">
        <el-tab-pane label="记录明细" name="TaskRecordList">
          <TaskRecordList v-if="card_index==='TaskRecordList'&&is_loading" />
        </el-tab-pane>
        <el-tab-pane label="近30天抽检" name="TaskRecordDay">
          <TaskRecordDay v-if="card_index==='TaskRecordDay'" />
        </el-tab-pane>
        <el-tab-pane label="近12月抽检" name="TaskRecordMonth">
          <TaskRecordMonth v-if="card_index==='TaskRecordMonth'" />
        </el-tab-pane>
      </el-tabs>
    </div>

    <ViewFile ref="ViewFile" />
  </div>
</template>

<script>
import moment from "moment/moment";
import TaskRecordCount from "./components/taskrecord/TaskRecordCount";
import TaskRecordList from "./components/taskrecord/TaskRecordList";
import TaskRecordDay from "./components/taskrecord/TaskRecordDay";
import TaskRecordMonth from "./components/taskrecord/TaskRecordMonth";
import Track from "../../../assets/js/trackHttp";
import ViewFile from "../Common/ViewFile";
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeader";

export default {
  name: "TaskCount",
  components: {SelectCdjProjectHeader, ViewFile, TaskRecordMonth, TaskRecordDay, TaskRecordList, TaskRecordCount},
  provide(){
    return{
      where:this.where,
      reginWhere:this.reginWhere
    }
  },
  data(){
    return{
      is_loading:false,
      where: {
        text:"",
        user_name:"",
        position_id:"",
        start_time:moment(new Date()).format("YYYY-MM-DD"),
        // month_db:moment(new Date()).format("YYYY-MM"),
        day_time:moment(new Date()).format("YYYY-MM-DD"),
      },
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[]
      },
      recordType: [
        {
          value: 'legal',
          label: '自催记录'
        },
        {
          value: 'litigation',
          label: '自讼记录'
        },
        {
          value: 'thirdlegal',
          label: '第三方记录'
        }
      ],
      forbiddenStartTime:{
        disabledDate: this.disabledDateMethod,
      },
      card_index:"TaskRecordList",
      position_list:[
        {id:70,name:"项目经理"},
        {id:79,name:"项目管家经理"},
        {id:104,name:"项目总经理"},
        {id:147,name:"区域经理"},
        {id:100,name:"区域总经理"},
        {id:165,name:"分公司管家经理"},
        {id:115,name:"分公司副总经理"},
        {id:87,name:"分公司总经理"},
        {id:370,name:"主席助理"},
      ]
    }
  },
  activated() {
    const that=this;
  },
  methods:{
    disabledDateMethod(time){
      let month_time=moment(time).format("YYYYMM");
      let start_month_time=202308;
      let end_month_time=moment(new Date()).format("YYYYMM");
      return !(month_time >= start_month_time && month_time <= end_month_time);
    },
    exportExcel(){
      const that=this;
      ERP.showLoading()
      let start_time = that.reginWhere.start_time ?  that.reginWhere.start_time : moment(new Date()).format("YYYYMMDD");
      let end_time = that.reginWhere.end_time ?  that.reginWhere.end_time : moment(new Date()).format("YYYYMMDD");
      let where = {
        ...that.where,
        project_ids:that.reginWhere.project_ids,
        project_regin: that.reginWhere.project_region,
        project_id:that.reginWhere.project_name,
        project_type:that.reginWhere.type_id,
      }

      // 请求
      Track.post('logger/ExpeditingInspection/getUserExportExcel', {...where}, res => {
        ERP.hideLoading();
        if (res.code) {
          that.$refs.ViewFile.show({
            width: '90vw',
            height:'80vh',
            title:"文件预览",
            src:Track.getBaseURL()+res.data,
            download(){
              window.open( Track.getBaseURL()+res.data)
            }
          })
        }
      })
    },
    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common";
.content{
  padding: 10px;
  margin-left: 10px;

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/TaskCount.vue